import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { resultsDisclaimer } from "../../data/site";
import { SiteLink } from "../SiteLink";
import { VerdictVideo } from "./VerdictVideo";
export function CaseResult() {
  return <section id="case-result" aria-labelledby="result-title" className="on-dark bg-ink text-white" data-id="element-164" data-mp="ijdlak64be8r">
      <div className="page-container verdict-grid" data-id="element-165" data-mp="nd81veqffd3m">
        <div data-id="element-166" data-mp="sb01yw1865iw">
          <p className="eyebrow text-white" data-id="element-167" data-mp="sbjbppgq1nlu">Featured Case Study</p>
          <h2 id="result-title" className="mt-3 font-extrabold leading-[1.1] tracking-tight" data-id="element-168" data-mp="x9t6w02g4o7g">
            Behind the $27.5 million motorcycle verdict
          </h2>
          <p className="mt-4 text-[23px] font-bold leading-snug" data-id="element-169" data-mp="11bxy6s5f98qx">Motorcycle injury jury verdict</p>
          <p className="mt-2 text-meta text-white/90" data-id="element-170" data-mp="169zithihxg4i">Kent County, Michigan · May 3, 2024</p>
          <p className="mt-5 max-w-measure text-meta text-white/80" data-id="element-171" data-mp="334ce5loeo34p">
            The firm’s case report describes it as Michigan’s largest motorcycle injury verdict, based on its research.
          </p>
          <h3 className="mt-7 text-h3 font-bold" data-id="element-172" data-mp="2427nn6lux980">Holding a distracted driver accountable</h3>
          <p className="mt-4 max-w-measure text-white/90" data-id="element-173" data-mp="1z94w140n49ug">
            A driver using a phone app crossed the centerline and struck a rider, whose injuries included a leg amputation.
            Jason Waechter led the trial team for the rider and his wife, pursuing claims against the driver and her employer.
          </p>
          <SiteLink path="/27-million-motorcycle-injury-verdict/" className="mt-5 inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-white underline underline-offset-4 hover:decoration-2" data-id="element-174" data-mp="2mxekyet5hdpt">
            Read the full case study
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-175" data-mp="290iz1lrsvrsc" />
          </SiteLink>
          <p className="mt-5 max-w-measure border-t border-white/25 pt-4 text-meta text-white/80" data-id="element-176" data-mp="12jxioja6d71m">{resultsDisclaimer}</p>
        </div>
        <VerdictVideo data-id="element-177" data-mp="xizrjh76t2nz" />
      </div>
    </section>;
}